
import React from 'react';
import { CONFIG } from '../constants';
import { Award, CheckCircle, Quote, Shield } from 'lucide-react';

const AttorneySection: React.FC = () => {
  const portrait = CONFIG.attorneyPhoto;

  const highlights = [
    "Licensed in MD, DC, and VA",
    "20+ Years of High-Stakes Litigation",
    "Expert in Complex Civil Advocacy",
    "Personalized Strategy for Every Case"
  ];

  return (
    <section id="attorney" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-16 items-center">

          {/* Portrait Detail for context (Mobile/Tablet visible) */}
          <div className="lg:hidden mb-12 relative group">
            <div className="absolute -inset-4 bg-[#c5a059]/5 rounded-full blur-3xl"></div>
            <img
              src={portrait}
              alt="Principal Attorney"
              className="w-48 h-48 mx-auto rounded-full object-cover border-4 border-[#c5a059]/20 shadow-2xl grayscale"
            />
          </div>

          {/* Text Content */}
          <div className="lg:col-span-7">
            <span className="text-[#c5a059] font-bold text-xs tracking-[0.4em] uppercase mb-4 block">Personal Leadership</span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-8 text-gray-900 leading-tight">
              Direct Representation <br />From Your <span className="text-[#c5a059]">Lead Counsel</span>
            </h2>

            <div className="relative mb-10 pl-12">
              <Quote className="absolute top-0 left-0 w-8 h-8 text-[#c5a059] opacity-20" />
              <p className="text-xl text-gray-600 font-light leading-relaxed italic">
                "In my practice, results are built on a foundation of integrity and relentless preparation. I provide strategic representation for clients across Maryland, Washington D.C., and Virginia, ensuring their interests are championed in every jurisdiction."
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 mb-12">
              {highlights.map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#c5a059]" />
                  <span className="text-gray-700 font-medium text-sm">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-8 border-t border-gray-100 pt-10">
              <div className="flex flex-col">
                <span className="text-3xl font-serif font-bold text-gray-900">3</span>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">State Licenses</span>
              </div>
              <div className="w-[1px] h-10 bg-gray-200"></div>
              <div className="flex flex-col">
                <span className="text-3xl font-serif font-bold text-gray-900">20+</span>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Years Experience</span>
              </div>
              <div className="w-[1px] h-10 bg-gray-200"></div>
              <div className="flex flex-col">
                <span className="text-3xl font-serif font-bold text-gray-900">500+</span>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Cases Won</span>
              </div>
            </div>
          </div>

          {/* Badge / Achievement Side */}
          <div className="lg:col-span-5 relative">
            <div className="bg-[#fafafa] p-12 border border-gray-100 rounded-sm relative z-10">
              <div className="mb-8 bg-white p-6 shadow-xl flex items-center gap-4 transform -rotate-2 hover:rotate-0 transition-transform duration-500">
                <Award className="w-10 h-10 text-[#c5a059]" />
                <div>
                  <h4 className="font-bold text-sm text-gray-900">Tri-State Legal Award</h4>
                  <p className="text-xs text-gray-500">Recognized Excellence MD/DC/VA</p>
                </div>
              </div>

              <div className="mb-8 bg-white p-6 shadow-xl flex items-center gap-4 transform rotate-3 hover:rotate-0 transition-transform duration-500">
                <Shield className="w-10 h-10 text-[#c5a059]" />
                <div>
                  <h4 className="font-bold text-sm text-gray-900">Litigation Specialist</h4>
                  <p className="text-xs text-gray-500">Board Certified Advocate</p>
                </div>
              </div>

              <div className="bg-[#0a0a0a] p-10 text-white">
                <h4 className="font-serif font-bold text-xl mb-4 text-[#c5a059]">Book an Evaluation</h4>
                <p className="text-sm text-gray-400 mb-6 font-light">Discuss your legal matter directly with the principal attorney.</p>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full py-4 border border-[#c5a059] text-[#c5a059] hover:bg-[#c5a059] hover:text-white transition-all duration-300 font-bold text-xs tracking-widest uppercase"
                >
                  Schedule Now
                </button>
              </div>
            </div>

            {/* Background Accent */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#c5a059]/5 rounded-full blur-3xl -z-10"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AttorneySection;
